import React from 'react';
import './payment-media-card.scss';
import { isEmpty } from 'lodash';
import { HeaderCard, MediaItemView } from '../../components';
import { FileUploadOutput } from '@zonofi/common/types/interface';

interface PaymentMediaCardProps {
  mediaFile: FileUploadOutput[];
  onThreeDotPress?: (media: FileUploadOutput) => void;
}

export const PaymentMediaCard: React.FC<PaymentMediaCardProps> = ({
  mediaFile,
  onThreeDotPress,
}) => {
  if (isEmpty(mediaFile)) return null;

  return (
    <div className="payment-media-card">
      <HeaderCard
        title={'UPLOAD PAYMENT RECEIPT'}
        subtitle={
          'Upload your payment receipts. We accept JPG, PDF, PNG upto 5MB'
        }
      />
      <div className="payment-details-media-container">
        {mediaFile?.map((media, index) => (
          <MediaItemView
            key={`${media.lastModified}-${index}`}
            media={media}
            onThreeDotPress={(item) => onThreeDotPress?.(item)}
            // isDisable
          />
        ))}
      </div>
    </div>
  );
};
